import React from "react";

export default function Breadcrumb(props) {
    let { total, title, params, selected } = props;

    let paramsArray = params.map(item => {
        return item.param;
    });

    if (title) {
        return (
            <ul className="bc bc--all list-bc">
                <li style={{float: "left"}}><h2 style={{ fontSize: '1.1em' }}>{title}</h2></li>
                {/* { showHeart ? <Heart id={id} type={type} style={{width: "30px", height: "30px", float: "left", margin: "0 5px 0 5px"}} /> : ""} */}
                <li style={{float: "left"}}>{total > 0 ? `(${total})` : ''}</li>
            </ul>
        );
    } else if (countElems(selected)) {
        return (
            <ul className="bc list-bc">
                {paramsArray.map((paramName, paramIndex) => {
                    return (
                        selected[paramName] &&
                        selected[paramName].length > 0 && (
                            <li key={paramIndex} style={{ display: 'inline', marginRight: '10px' }}>
                                {selected[paramName].map((selectedItem, selectedIndex) => {
                                    return (
                                        <a href="" key={selectedIndex} style={{ textDecoration: 'none', marginRight: '8px' }}>
                                            <span style={{ fontSize: '1.1em', display: 'inline', fontWeight: 700, lineHeight: 1.2, marginBottom: '0.5rem' }}>{selectedItem.title}</span>
                                        </a>
                                    );
                                })}
                            </li>
                        )
                    );
                })}
                <li style={{ display: 'inline' }}>{total > 0 ? `(${total})` : ''}</li>
            </ul>
        );
    } else {
        return (
            <ul className="bc bc--all list-bc">
                <li className="d-flex align-items-end"><h1 style={{ fontSize: '1.1em', fontWeight: 700, lineHeight: 1.2, marginBottom: '0rem' }}>Összes találat</h1></li>
                <li>{total > 0 ? `(${total})` : ''}</li>
            </ul>
        );
    }

    function countElems(selected) {
        for (let key in selected) {
            if (selected[key].length > 0) return true;
        }

        return false;
    }
}
